import { render, staticRenderFns } from "./QnaPageCard.vue?vue&type=template&id=1c852ac6&scoped=true&"
import script from "./QnaPageCard.vue?vue&type=script&lang=ts&"
export * from "./QnaPageCard.vue?vue&type=script&lang=ts&"
import style0 from "./QnaPageCard.vue?vue&type=style&index=0&id=1c852ac6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c852ac6",
  null
  
)

export default component.exports